import { Form, Modal, notification } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/slices/modalsSlice";
import { createSubject, getSubjects } from "store/slices/subjectsSlice";
import SubjectForm from "./subject-form";

const NewSubjectModal = () => {
  const { t } = useTranslation();
  const [form] = Form?.useForm();
  const dispatch = useDispatch();

  const { isModalOpen, modalType } = useSelector((state) => state?.modals);
  const { loading } = useSelector((state) => state?.subjects);

  const open = isModalOpen && modalType === "new_subject";

  const onSubmit = async (values) => {
    try {
      await dispatch(createSubject(values))?.unwrap();
      await dispatch(getSubjects())?.unwrap();
      notification?.success({
        message: t("subjects.crud.form.success"),
      });
      onClose();
    } catch (error) {
      notification?.error({
        message: t("subjects.crud.form.error.failed"),
        description: error?.message,
      });
    }
  };

  const onClose = () => {
    form?.resetFields();
    dispatch(closeModal());
  };

  return (
    <Modal
      title={t("subjects.crud.new")}
      open={open}
      onCancel={onClose}
      onOk={() => form?.submit()}
      confirmLoading={loading}
    >
      <SubjectForm form={form} onSubmit={onSubmit} loading={loading} />
    </Modal>
  );
};

export default NewSubjectModal;
